

import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import i18n from "./i18n/i18n.js";

console.log(i18n.resolvedLanguage);


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

